import * as React from "react";

function SvgCrossCircleIcon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 194 194" {...props}><path d="M96.9 2c-52.4 0-95 42.6-95 95s42.6 95 95 95 95-42.6 95-95-42.6-95-95-95zm47.4 131.5l-10.6 10.6-36.5-36.5-36.5 36.5-10.6-10.6L86.6 97 50.1 60.5l10.6-10.6 36.5 36.5 36.5-36.5 10.6 10.6L107.8 97l36.5 36.5z" /></svg>;
}

export default SvgCrossCircleIcon;